import React, { useState, useEffect } from 'react';
import AppBar, { AppBarProps } from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import {default as MuiButton} from '@mui/material/Button';
import Button from '../Button/Button';
import MobileButton from '../MobileButton/MobileButton';
import MenuItem from '@mui/material/MenuItem';
import NavbarLogo from '../../images/logo-grupo-gm.png';
import NavbarLogoDark from '../../images/logo-grupo-gm-dark.png';
import NavbarLogoLight from '../../images/logo-grupo-gm-light.png';
import NavbarLogoMobile from '../../images/logo-grupo-gm-mobile.png';

import { styled } from '@mui/material/styles';
import navbarStyles from './NavbarStyles';

const pages = ['Nosotros', 'Contacto', 'Blog'];
const pagesHref = ['/#beneficios', '/contacto', '/blog'];

type NavbarProps = {
  fixedScrolled?: boolean;
  contactRibbon?: boolean;
};

const StyledAppBar = styled(AppBar)<AppBarProps>(({ theme }) => navbarStyles());

const Navbar: React.FC<NavbarProps> = (props) => {
  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);
  
  const [ scrolled, setScrolled ] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);

  const { fixedScrolled, contactRibbon } = props;

  const isMobile = width <= 1024;

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  // const handleClick = (event: React.MouseEvent<HTMLElement>) => {
  //   setAnchorEl(event.currentTarget);
  // };

  const handleClose = () => {
    setAnchorEl(null);
  };


  useEffect(() => {
    const onScroll = () => {
        if (window.scrollY > 50) {
            setScrolled(true);
        } else {
            setScrolled(false);
        }
    }

    const handleWindowSizeChange = () => {
      setWidth(window.innerWidth);
    }

    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', handleWindowSizeChange);

    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  })

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleClickSubMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };


  return (
    <StyledAppBar className={(scrolled || fixedScrolled) ? 'scrolled' : ''}>
      {contactRibbon &&
        <div id="contact-ribbon" className="flex items-center justify-center text-center py-1 w-full">
          <div className='container flex flex-row justify-center gap-4'>
            <a href='tel:7751274603'>Tel. 775 127 4603</a>
          </div>
        </div>
      }
      <Container maxWidth="xl" className={(scrolled || fixedScrolled) ? 'innerContainerScrolled' : ''}>
        <Toolbar disableGutters>
          <a className='relative mr-12' href="/" title="Grupo GM">
            <img id="navbar-logo" className={'h-7 hidden lg:flex w-fit' + (scrolled || fixedScrolled ? ' logoScrolledIn' : ' logoScrolledOut')} src={NavbarLogoLight} alt="Grupo GM"/>
            <img id="navbar-logo" className={'absolute top-0 left-0 bottom-0 right-12 w-full h-full' + (scrolled || fixedScrolled ? ' logoScrolledOut' : ' logoScrolledIn')} src={NavbarLogoDark} alt="Grupo GM"/>
          </a>

          <Box className="flex lg:hidden" >
            <IconButton
              size="large"
              aria-label="Account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              className="block lg:hidden"
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
            >
              <MenuItem key={'Servicios'} onClick={handleClickSubMenu}>
                <Typography textAlign="center">Servicios</Typography>
              </MenuItem>
              {isMobile ? <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
              >
                <MenuItem onClick={handleClose} style={{paddingTop: 0, paddingBottom: 0}}><a style={{paddingTop: '6px', paddingBottom: '6px', textDecoration: 'none', color: 'black'}} href="/renta-cajas-secas-hidalgo">Renta de Cajas Secas</a></MenuItem>
                <MenuItem onClick={handleClose} style={{paddingTop: 0, paddingBottom: 0}}><a style={{paddingTop: '6px', paddingBottom: '6px', textDecoration: 'none', color: 'black'}} href="/renta-plataformas-hidalgo">Renta de Plataformas</a></MenuItem>
                <MenuItem onClick={handleClose} style={{paddingTop: 0, paddingBottom: 0}}><a style={{paddingTop: '6px', paddingBottom: '6px', textDecoration: 'none', color: 'black'}} href="/venta/catalogo">Venta de Refacciones</a></MenuItem>
              </Menu> : ''}
              {pages.map((page, i) => (
                <a key={`navbar-button-${i}`} href={pagesHref[i]} style={{color: 'inherit', textDecoration: 'none'}}>
                  <MenuItem key={page} onClick={handleCloseNavMenu}>
                    <Typography textAlign="center">{page}</Typography>
                  </MenuItem>
                </a>
              ))}
            </Menu>
          </Box>
          <a href="/" className='h-8 flex grow lg:hidden w-fit items-center justify-center' title="Grupo GM">
            <img className='h-7 flex grow w-[2rem] object-contain' src={NavbarLogoMobile} alt="Grupo GM"/>
          </a>
          <Box className="hidden grow lg:flex" >
            <MuiButton
                id="navbar-menu-button"
                key={'Servicios'}
                onClick={handleClickSubMenu}
                sx={{ my: 2, color: 'white' }}
              >Servicios
            </MuiButton>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
            >
              <MenuItem onClick={handleClose} style={{paddingTop: 0, paddingBottom: 0}}><a style={{paddingTop: '6px', paddingBottom: '6px', textDecoration: 'none', color: 'black'}} href="/renta-cajas-secas-hidalgo">Renta de Cajas Secas</a></MenuItem>
              <MenuItem onClick={handleClose} style={{paddingTop: 0, paddingBottom: 0}}><a style={{paddingTop: '6px', paddingBottom: '6px', textDecoration: 'none', color: 'black'}} href="/renta-plataformas-hidalgo">Renta de Plataformas</a></MenuItem>
              <MenuItem onClick={handleClose} style={{paddingTop: 0, paddingBottom: 0}}><a style={{paddingTop: '6px', paddingBottom: '6px', textDecoration: 'none', color: 'black'}} href="/venta/catalogo">Venta de Refacciones</a></MenuItem>
            </Menu>
            {pages.map((page, i) => (
              <MuiButton
                id="navbar-menu-button"
                key={page}
                onClick={handleCloseNavMenu}
                href={pagesHref[i]}
                sx={{ my: 2, color: 'white' }}
              >
                {page}
              </MuiButton>
            ))}
          </Box>

          <Box className="grow-0">
            <Button href="/contacto" className="hidden lg:inline-block">
              Solicitar cotización
            </Button>
            <MobileButton href="/contacto" className="inline-block lg:hidden">
              Cotizar
            </MobileButton>
          </Box>
        </Toolbar>
      </Container>
    </StyledAppBar>
  )
}

export default Navbar